var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("欢迎使用，请联系管理员配置你的角色菜单")])
}
var staticRenderFns = []

export { render, staticRenderFns }